import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppConst';

const RoleBasedRedirect = React.lazy(() => import('./RoleBasedRedirect'));

export const homeConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/home',
    element: <RoleBasedRedirect />,
  },
];
